import type { PropsWithChildren } from 'react'
import { createContext, useContext, useEffect, useRef, useState } from 'react'
import { useOTLContext } from '../../auth'
import { useMoteConversationContext } from '../../mote'

export const MoteLandingPageOTLContext = createContext(0)

export function MoteLandingPageOTLProvider(props: PropsWithChildren) {
  const otlRefreshKey = useOTLContext()
  const otlRefreshKeyRef = useRef(otlRefreshKey)
  const moteConversationContext = useMoteConversationContext()
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    if (otlRefreshKey !== otlRefreshKeyRef.current) {
      moteConversationContext.reload().then(() => setRefreshKey(Date.now()))
    }
  }, [otlRefreshKey])

  useEffect(() => {
    otlRefreshKeyRef.current = otlRefreshKey
  })

  return (
    <MoteLandingPageOTLContext.Provider value={refreshKey}>
      {props.children}
    </MoteLandingPageOTLContext.Provider>
  )
}

export function useMoteLandingPageOTLContext() {
  return useContext(MoteLandingPageOTLContext)
}
